import React from 'react';
import Leftpanel from '../layout/Leftpanel';
import Header from '../layout/Header';

const index = () => {
    return (
        <div className='container-fluid'>
            <div className='dbMain'>
                <Leftpanel />
                <div className='dbRight'>
                    <Header link="/dashboard" title="Registration" description="" />
                    <div className='commonBase'>
                        <form>
                            <div className='browseimg'>BrowseImage</div>
                            <div className='row'>
                                <div className='col-md-12 mb-3'>
                                    <input type="text" id="companyname" className="form-control" placeholder="Mother Company" name="companyname" />
                                </div>
                                <div className='col-md-12 mb-3'>
                                    <input type="text" id="companyurl" className="form-control" placeholder="Company Url" name="company url" />
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-6 mb-3'>
                                    <input type="text" id="" className="form-control" placeholder="John" name="" />
                                </div>
                                <div className='col-md-6 mb-3'>
                                    <input type="text" id="" className="form-control" placeholder="Watson" name="" />
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-12 mb-3'>
                                    <select className='form-control'>
                                        <option selected hidden>Select Country</option>
                                    </select>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-6 mb-3'>
                                    <select className='form-control'>
                                        <option selected hidden>State</option>
                                    </select>
                                </div>
                                <div className='col-md-6 mb-3'>
                                    <select className='form-control'>
                                        <option selected hidden>City</option>
                                    </select>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-12 mb-3'>
                                    <textarea className='form-control' placeholder='Address'></textarea>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-6 mb-3'>
                                    <input type="number" id="" className="form-control" placeholder="number" name="" />
                                </div>
                                <div className='col-md-6 mb-3 checkmail'>
                                    <input type="email" id="" className="form-control" placeholder="email" name="" />
                                    <i className="fa-solid fa-circle-check"></i>
                                </div>
                            </div>


                            <div className='row'>
                                <div className='col-md-12 mb-3'>
                                    <input type="text" id="" className="form-control" placeholder="Job Title" name="" />
                                </div>
                                <div className='col-md-12 mb-3'>
                                    <input type="text" id="" className="form-control" placeholder="Role" name="" />
                                </div>
                            </div>

                            <button type="button" className='commonButton'>Save</button>

                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default index